module.exports = __webpack_public_path__ + "static/media/Cottonv3.0.3f8793e0.PNG";